import { date } from 'quasar'
import * as Enumerable from 'linq-es2015'
import OrganizationAddEditModel from './organizationaddeditmodel-dialog-screen.vue';
import OrganizationListModel from './organizationlistmodel-deluxelist-screen.vue';


export default {
    data: function () {
        return {
            screenKey: "OrganizationListModel",
            loading: false,
            actionLocked: false,
            modelId: this.$route.params.id ?? 0, // Parent Model ID,
            model: { },
            
            columns: [
                {
                    name: 'Id',
                    label: 'Id',
                    align: 'left',
                    field: row => row.Id,
                    sortable: false,
                    style: '',
                    
                    isVisible: () => false
                },
                {
                    name: 'Name',
                    label: 'Name',
                    align: 'left',
                    field: row => row.Name,
                    sortable: true,
                    style: '',
                    
                    isVisible: () => true
                },
                {
                    name: 'Code',
                    label: 'Code',
                    align: 'left',
                    field: row => row.Code,
                    sortable: true,
                    style: '',
                    
                    isVisible: () => true
                },
                {
                    name: 'IsDisabled',
                    label: 'Status',
                    align: 'left',
                    field: row => row.IsDisabled,
                    sortable: true,
                    style: '',
                    
                    isVisible: () => true
                },
                {
                    name: 'Actions',
                    label: 'Actions',
                    align: 'center',
                    field: row => row.Actions,
                    sortable: false,
                    style: 'min-width: 200px;max-width: 200px',
                    isVisible: () => true
                },

            ],
            columnsVisible: ['Name', 'Code', 'IsDisabled', 'Actions'],
            dataSource: [],
            
            filter: null,
            presetFilter: null,
            advancedFilter: Object.keys(this.$route.query).length !== 0 ? this.$prepareAdvancedFilter(this.$route.query) : null,
            selected: [],
            page: 1,
            pageSize: 50,
            hasMoreRows: true,
            pagination: {
                sortBy: 'Id',
                descending: false,
                rowsNumber: 0 // Need for 'QTable Request' event
            },
            applicationResources: null,
            toolTipStates: {},
            localTimezoneOffset: new Date().getTimezoneOffset(),
        }
    },

    methods: {

        onScroll({ to, ref }) {
            if (this.loading !== true && this.hasMoreRows && to === this.dataSource.length - 1) {
                this.loading = true;
                this.page++;

                this.onLoadListDataSource({
                    page: this.page,
                    pageSize: this.pageSize,
                    filter: this.filter,
                    localTimezoneOffset: this.localTimezoneOffset,
                    advancedFilter: this.advancedFilter,
                    sortBy: this.pagination.sortBy,
                    descending: this.pagination.descending,
                    resetDataSource: false
                });
            }
        },

        onRequest(props) {
            this.loading = true;
            this.page = 1;

            this.onLoadListDataSource({
                page: this.page,
                pageSize: this.pageSize,
                filter: props.filter,
                localTimezoneOffset: this.localTimezoneOffset,
                advancedFilter: this.advancedFilter,
                sortBy: props.pagination.sortBy,
                descending: props.pagination.descending,
                resetDataSource: true
            });
        },

        onClearFilterActionClick() {
            this.filter = null;
            this.presetFilter = null;
            this.advancedFilter = null;
            this.page = 1;
            this.refreshScreen();
        },

        async refreshScreen() {
            this.modelId = this.$route.params.id ?? 0;
            this.page = 1;
            this.selected = [];

            this.onLoadFieldDataSources();

            await this.onLoadListDataSource({
                page: this.page,
                pageSize: this.pageSize,
                filter: this.filter,
                localTimezoneOffset: this.localTimezoneOffset,
                advancedFilter: this.advancedFilter,
                sortBy: this.pagination.sortBy,
                descending: this.pagination.descending,
                resetDataSource: true
            });
        },

        applyPresetFilter(value) {
            this.advancedFilter = this.presetFilter?.Filter;
            this.page = 1;
            this.refreshScreen();
        },

        onCreateActionClick() {
            if (this.actionLocked) {
                return;
            }
            this.actionLocked = true;   
                
            this.$q.dialog({
                component: OrganizationAddEditModel,
                parent: this,
                index: 0,
                modelId: 0,
                modelObject: null,
                actionLabel: 'Save',
                actionTitle: 'Create',
                editMode: true
            }).onOk((payload) => {
                this.dataSource.splice(0, 0, payload.model);
            }).onDismiss(() => {
                this.actionLocked = false;
            });
        },

        onEditActionClick(rowKey, rowIndex, row) {
            if (this.actionLocked) {
                return;
            }
            this.actionLocked = true;   
                
            this.$q.dialog({
                component: OrganizationAddEditModel,
                parent: this,
                index: rowIndex,
                modelId: rowKey,
                modelObject: row,
                actionLabel: 'Save',
                actionTitle: 'Edit',
                editMode: true
            }).onOk((payload) => {
                var currentItemIndex = this.dataSource.map(e => { return e.Id; }).indexOf(rowKey);
                this.dataSource.splice(currentItemIndex, 1, payload.model);
            }).onDismiss(() => {
                this.actionLocked = false;
            });
        },

        onDeleteActionClick(rowKey, rowIndex, row) {
            if (this.actionLocked) {
                return;
            }
            this.actionLocked = true;
            
            this.$q.dialog({
                title: 'Confirm',
                message: 'Are you sure?',
                cancel: true,
                persistent: true
            }).onOk(() => {
                if (this.onDeleteModelDataSource(rowKey, row)) {
                    var currentItemIndex = this.dataSource.map(e => { return e.Id; }).indexOf(rowKey);
                this.dataSource.splice(currentItemIndex, 1);
                }
            }).onDismiss(() => {
                this.actionLocked = false;
            });
        },

        async onLoadListDataSource(params) {
            try {
                this.loading = true;

                let startRow = (params.page - 1) * params.pageSize;
                let fetchCount = params.pageSize;

                let requestBody = {
                    Skip: startRow,
                    Take: fetchCount + 1,
                    Filter: params.filter,
                    LocalTimezoneOffset: params.localTimezoneOffset,
                    AdvancedFilter: params.advancedFilter,
                    OrderBy: params.sortBy ? params.sortBy : 'Id',
                    OrderByDescending: params.descending
                };

                let response = await this.$http.post('/api/ui/organizations/'.replace('{id}', this.modelId), requestBody, {  });
                let listViewDataSource = response.body;

                if (listViewDataSource.Rows.length > fetchCount) {
                    this.hasMoreRows = true;
                    listViewDataSource.Rows.pop();
                } else {
                    this.hasMoreRows = false;
                }

                if (params.resetDataSource) {
                    this.dataSource.splice(0, this.dataSource.length, ...listViewDataSource.Rows);
                } else {
                    this.dataSource.push(...listViewDataSource.Rows);
                }

                if (response.body.Metadata) {
                    this.model = response.body.Metadata;
                    
                }

                this.pagination.sortBy = params.sortBy;
                this.pagination.descending = params.descending;
                if (listViewDataSource.TotalRows) {
                    this.pagination.rowsNumber = listViewDataSource.TotalRows;
                }
                
            }
            catch (ex) {
                this.$processException(ex);
            }
            finally {
                this.loading = false;
            }
        },

        async onDeleteModelDataSource(id, params) {
            try {
                this.loading = true;

                let url = this.$prepareServerUrl('/api/ui/organizations/{id}', id, params);
                let response = await this.$http.delete(url, {  });
                this.$processServerJsonResponse(response.body, this.refreshScreen);
            }
            catch (ex) {
                this.$processException(ex);
            }
            finally {
                this.loading = false;
            }
        },

        
        onLoadFieldDataSources() {
            
        },
    },

    computed: {
        screenTitle: function () {
            return 'Organizations';
        },

        
    },

    watch: {
        // Reload data if the route changed manually from browser address bar
        $route: 'refreshScreen'
    },

    mounted: async function () {
        this.refreshScreen();

    }
}